import React, { Component, PropTypes } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { translate } from 'react-i18next'
import PlaylistItem from './item'

/* Utilities */
import _ from 'lodash'

/* Widgets */
import InfoText from 'widget/info-text'
import {
  RemoveDialog,
  SCHEME as REMOVE_DIALOG_SCHEME
} from 'widget/remove-dialog'
import { Icon, ICON, SCHEME as ICON_SCHEME } from 'widget/icon'


/* Selectors */
import { getCreatedItem } from 'react-redux/selectors/playlist'

/* Styles */
import "./created.css"

/* Single Asset Item shown in asset list */
class PlaylistCreated extends Component {

  constructor() {
    super()
    this.state = {
    }
  }

  componentDidMount() { }

  componentWillReceiveProps(nextProps) { }


  getListItemClass() {
    const {  } = this.props
    var className = "playlist-created component"
    return className
  }

  /**
  * Render Asset Items as list elements
  */
  render() {
    const {
      t,
      uid,
      tid,
      name,
      completed,
    } = this.props
    if (completed) return (
      <PlaylistItem uid={ uid } key={ uid }/>
    )
    return (
      <li
        className={ this.getListItemClass() }
        key={ tid }
        data-tid={ tid }
      >
        <div className="border">
          <div className="detail">
            <div className="label">
              {name}
            </div>
          </div>
        </div>
      </li>
    )
  }
}

PlaylistCreated.propTypes = {
  tid: PropTypes.string.isRequired,
}

const mapStateToProps = getCreatedItem

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
    },
    dispatch
  )
}
/*
function mergeProps(stateProps, dispatchProps, ownProps){
  return Object.assign(
    {},
    dispatchProps,
    ownProps
  )
}*/

const reduxComponent = connect(
  mapStateToProps,
  mapDispatchToProps
)(PlaylistCreated)
const translatedComponent = translate([], { withRef: true })(reduxComponent)
export default translatedComponent



// WEBPACK FOOTER //
// ./src/app/component/playlist/created.jsx